import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { repairSettingsApi } from './repair-settings.api';
import type { RepairReasonsListParams } from '../types';

export const repairSettingsKeys = {
  all: ['repair-settings'] as const,
  public: () => [...repairSettingsKeys.all, 'public'] as const,
  reasons: () => [...repairSettingsKeys.all, 'reasons'] as const,
  reasonsList: (destId: number, params: RepairReasonsListParams) =>
    [...repairSettingsKeys.reasons(), destId, params] as const
};

export const repairSettingsQueries = {
  public: () =>
    queryOptions({
      queryKey: repairSettingsKeys.public(),
      queryFn: repairSettingsApi.public,
      staleTime: 5 * 60 * 1000
    }),

  reasonsList: (destId: number, params: RepairReasonsListParams = {}) =>
    queryOptions({
      queryKey: repairSettingsKeys.reasonsList(destId, params),
      queryFn: () => repairSettingsApi.listReasons(destId, params),
      placeholderData: keepPreviousData
    })
};
